(() => {
  const menus = new WeakMap();

  function initialize(root) {
    if (menus.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let activeItem = null;
    let closeTimer;
    let switchTimer;
    const items = Array.from(root.querySelectorAll(':scope > ul > .mega-menu-hover'));

    const clearTimers = () => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);
    };

    const open = (item) => {
      clearTimers();
      activeItem = item?.querySelector('.mega_menu-child') ? item : null;
      items.forEach((entry) => {
        const expanded = entry === activeItem;
        entry.classList.toggle('is-menu-open', expanded);
        const trigger = entry.querySelector(':scope > .mega-menu > a');
        const panel = entry.querySelector('.mega_menu-child');
        if (trigger && panel) {
          trigger.setAttribute('aria-expanded', String(expanded));
          panel.inert = !expanded;
        }
      });
    };

    const close = () => open(null);
    items.forEach((item) => {
      const panel = item.querySelector('.mega_menu-child');
      const trigger = item.querySelector(':scope > .mega-menu > a');
      if (panel && trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.inert = true;
        panel.addEventListener('pointerenter', () => open(item), options);
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === ' ') {
            event.preventDefault();
            open(item);
            panel.querySelector('a')?.focus();
          }
        }, options);
      }
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        clearTimers();
        // Delay switching so crossing another row does not replace the panel.
        if (activeItem && activeItem !== item) {
          switchTimer = setTimeout(() => open(item), 180);
        } else {
          open(item);
        }
      }, options);
      item.addEventListener('pointerleave', () => clearTimeout(switchTimer), options);
      item.addEventListener('focusin', () => open(item), options);
    });

    root.addEventListener('pointerenter', () => clearTimeout(closeTimer), options);
    root.addEventListener('pointerleave', () => {
      clearTimers();
      closeTimer = setTimeout(() => {
        if (!root.contains(document.activeElement)) close();
      }, 300);
    }, options);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) close();
    }, options);
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !activeItem) return;
      const trigger = activeItem.querySelector(':scope > .mega-menu > a');
      trigger?.focus();
      close();
      event.preventDefault();
      event.stopPropagation();
    }, options);
    root.setAttribute('data-mega-menu-ready', '');
    menus.set(root, () => {
      clearTimers();
      controller.abort();
      menus.delete(root);
    });
  }

  const initializeWithin = (scope) => scope.querySelectorAll('[data-mega-menu-navigation]').forEach(initialize);
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mega-menu-navigation]').forEach((root) => menus.get(root)?.());
  });
})();
